// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_DESCRIPTION_DEFAULT_FALLBACK = "T\u011bhotenstv\u00ed, porod a miminko - v\u0161echno pro maminky a budouc\u00ed maminky, Bazar - d\u011btsk\u00e9 oble\u010den\u00ed, hra\u010dky, autoseda\u010dky, ko\u010d\u00e1rky";
export const SEO_TITLE_DEFAULT_FALLBACK = "Modr\u00fd kon\u00edk - V\u0161echno pro maminky a budouc\u00ed maminky";
